module.exports = __webpack_public_path__ + "media/marketing_area/fallBanner-6b35bb5f.png";